import React from "react";

// importing stylesheets:
import "./Firefly.css";

const Firefly = () => {
  return (
    <div>
      <div className="firefly"></div>
      <div className="firefly"></div>
      <div className="firefly"></div>
      <div className="firefly"></div>
      <div className="firefly"></div>
      <div className="firefly"></div>
      <div className="firefly"></div>
      <div className="firefly"></div>
      <div className="firefly"></div>
    </div>
  );
};

export default Firefly;
